import React from "react";
import styled from "styled-components";
import Title from "@airasia/phoenix-components/components/Title";
import Text from "@airasia/phoenix-components/components/Text";
import flight_soldout from "../../images/flight_soldout.svg";
import { Button } from "@airasia/phoenix-components/components";

const StyledText = styled(Text)`
    font-size: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    @media (max-width: 600px){
        text-align: center;
        font-size: 1.25rem;
        line-height: 1.5;
    }
`;

const ImageBox = styled.div`
    width: 240px;
    height: 100%;
    background-image: url("${flight_soldout}");
    background-repeat: no-repeat;
    background-size: auto 100%;
    @media (max-width: 600px){
        width: 100%; 
        height: 140px;
        background-position: center;
    }
`;

const Container = styled.div`
    width: 100%;
    background-color: #ffffff;
    height: 180px;
    box-shadow: 0px 0px 8px 0px #d2d2d2;
    border-radius: 4px;
    gap: 48px;
    padding: 12px;
    margin: 8px auto 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 600px){    
        flex-direction: column;
        width: 100%;
        overflow-x: hidden;
        box-sizing: border-box;
        height: min-content;
        gap: 8px;
    }
`;

const AlternateRouteCard = ({handleClick = ()=>{}, stationName, stationCode}) => {
    return(
        <Container>
            <ImageBox />
            <StyledText>
                We have flights from Kuala Lumpur (KUL) to {stationName} ({stationCode})
                <Button color='primary' width='120px' handleClick={handleClick}>
                    View Flights
                </Button>
            </StyledText>

        </Container>
    );
};

export default AlternateRouteCard;